export const getHelpMenuLink = (language: string) => {
  return `https://help.hotmart.com/${language}/categories/comprei-pela-hotmart-e-preciso-de-ajuda/360003231591`
}

export const PURCHASES_MENU = `https://purchase.hotmart.com/`

export const featureToggles = {
  featureNewCommunityMenuStructure: JSON.parse(
    process.env.FEATURE_NEW_COMMUNITY_MENU_STRUCTURE as string
  ),
  featureShouldRenderRoomsAndGroups: Number(
    JSON.parse(process.env.FEATURE_COMMUNITY_OWNER_ID as string)
  ),
  featureBanMemberCommunity: JSON.parse(process.env.FEATURE_UNBAN_USER as string)
}
